import { Pipe, PipeTransform } from '@angular/core';

import { PortalOrderNode } from '@app/services/api/api.types';
import { State } from '@app/services/state/state.service';
import { calculateAdditionalProductsTotal } from '@app/utils/utils';
import { getBasicChangeFeeTotal } from '@app/utils/basic-change-fee';

@Pipe({
  name: 'getTotalAmount',
})
export class GetTotalAmountPipe implements PipeTransform {
  transform(soldAmount = 0, state: State, portalOrder?: PortalOrderNode | null) {
    return (
      soldAmount +
      calculateAdditionalProductsTotal(state, portalOrder) +
      getBasicChangeFeeTotal(portalOrder)
    );
  }
}
